import { render } from "./PermissionBadge.vue?vue&type=template&id=03a99397"
import script from "./PermissionBadge.vue?vue&type=script&lang=js"
export * from "./PermissionBadge.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__